export default __webpack_public_path__ + "assets/Lycan Druid.webp";